import React from "react";
import "./image.scss";

interface IProps {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  handleClick?: () => void;
  width?: number;
  height?: number;
  handleOnError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const Image: React.FC<IProps> = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  handleClick = () => {},
  width,
  height,
  handleOnError,
}) => {
  return (
    <div className={`image-container ${className}`} onClick={handleClick}>
      <img
        className={imgClassName}
        src={src}
        alt={alt}
        height={height}
        width={width}
        onError={handleOnError}
      />
    </div>
  );
};

export default Image;
